module.exports = __webpack_public_path__ + "img/product_56.4fb98db.svg";